import React from 'react';

import {floatPriceFromFormatted} from '@optimaxdev/utils';
import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature, useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {ApplicationStoreType} from 'desktop/store';
import {OrderReviewTotalsSegmentsType} from 'desktop/types/orderReviewTotalsType';

import {useGetIsShowTBD} from '../../hooks/useGetIsShowTBD/useGetIsShowTBD';
import {getActualTotalRows} from '../../store/selectors/orderReviewTotals/orderReviewTotals';

import {
    DUE_NOW,
    GRAND_TOTAL_TITLE,
    SALES_TAX_TITLE,
    SUBTOTAL_TITLE,
    TAX_ROW,
} from '../../store/selectors/orderReviewTotals/utils/prepareTotals';

import s from './cartTotals.scss';

export type PropsType = {
    rows: OrderReviewTotalsSegmentsType[];
};

/**
 * Cart Footer for checkout page
 *
 * @constructor
 */
export const CartTotals: React.FC<PropsType> = ({rows}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const isPriceZero = (price: number) => !price || floatPriceFromFormatted(price) === 0;
    const isShowTBD = useGetIsShowTBD();
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    const dynamicClasses: {[key: string]: string} = {
        discount: [s.discount, isDiscountColor ? s.isDiscountColor : ''].join(' '),
    };

    return (
        <ul className={classNames(s.wrapper, {[s.wrapperFacelift]: isFacelift})}>
            {rows
                .filter(it => it.title !== GRAND_TOTAL_TITLE)
                .map(({code, price, title}) => (
                    <li
                        className={classNames(s.row, dynamicClasses[code], {
                            [s.facelift]: isFacelift,
                        })}
                        key={code}
                    >
                        <span>
                            {[SUBTOTAL_TITLE, SALES_TAX_TITLE].includes(String(title))
                                ? `${title}:`
                                : title}
                        </span>
                        <span>
                            <span className={s.price}>
                                {isPriceZero(price) &&
                                ![TAX_ROW.code, DUE_NOW.code].includes(code) ? (
                                    <span>Free</span>
                                ) : (
                                    <span>
                                        {TAX_ROW.code === code &&
                                        isPriceZero(price) &&
                                        isShowTBD ? (
                                            <span>TBD</span>
                                        ) : (
                                            <Price>{price}</Price>
                                        )}
                                    </span>
                                )}
                            </span>
                        </span>
                    </li>
                ))}
        </ul>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    rows: getActualTotalRows(store),
});

export const CartTotalsConnected = connect(mapStateToProps)(CartTotals);
